'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react/15.2.0/react/react.js
 ** module id = 2
 ** module chunks = 0
 **/